var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-btn",attrs:{"to":_vm.data.to}},[_vm._v(" "+_vm._s(_vm.data.name)+" "),_c('div',{staticClass:"optional-dropdown__container",class:{ 'hidden-dropdown': _vm.is_hidden }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }